import styled from 'styled-components'
import Description, { PolygonDescription } from './description'
import BuyMember from './buy-member'
import Rules from './rules'
import { STATICS } from 'static'
import { useIsPolygon } from 'hooks/useEnvConfig'
import { useVipInfo } from 'context/VipInfoContext'
import polygonVip_img from 'static/image/polygon/vip.svg'
import rect_img from 'static/image/polygon/rect.svg'

export default function Vip() {
  const isPolygon = useIsPolygon()
  return isPolygon ? <Polygon /> : <BSC />
}

function Polygon() {
  const { isRegistered } = useVipInfo()

  return isRegistered ? (
    <PolygonVip />
  ) : (
    <VipWrapper>
      <HeadTitle>Cocos-BCX campaigns are open for all membership!</HeadTitle>
      <PolygonDescription />
    </VipWrapper>
  )
}

function PolygonVip() {
  return (
    <PolygonVipWrapper>
      <PolygonVipContainer>
        <img src={polygonVip_img} alt="" className="vip-img" />
        <PolygonVipContent>
          <p className="t1">Welcome to use Polygon mode!</p>
          <p className="t2">Your Cocos-BCX membership identity & rights are applicable on Polygon network.</p>
        </PolygonVipContent>
      </PolygonVipContainer>
      <PolygonDescContainer>
        <p className="title">Membership Privileges</p>
        <PolygonDescContent>
          <p>* Only members can participate in Mystery box campaigns.</p>
          <p>* Only members are eligible for IGO , acquiring computing power.</p>
          <p>* Members can participate in DAO governance.</p>
          <p>* Only members can get COCOS commissions.</p>
          <p>* Members will get irregularly scheduled incentives, giveaways or airdrops.</p>
        </PolygonDescContent>
      </PolygonDescContainer>
    </PolygonVipWrapper>
  )
}

function BSC() {
  return (
    <VipWrapper>
      <HeadTitle>Cocos-BCX campaigns are open for all membership!</HeadTitle>
      <Description />
      <BuyMember />
      <Rules />
    </VipWrapper>
  )
}

const VipWrapper = styled.div`
  width: 1150px;
  margin: 0 auto;
  padding-top: 90px;
  background-image: url(${STATICS.VipBannerBg});
  background-repeat: no-repeat;
  background-position-y: 40px;
  background-position-x: -80px;
  padding-bottom: 100px;
`

const HeadTitle = styled.h3`
  font-size: 60px;
  line-height: 74px;
  text-align: center;
  padding: 0 150px;
  width: 100%;
  color: #fff;
`

const PolygonVipWrapper = styled.div`
  width: 100%;
  margin-top: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const PolygonVipContainer = styled.div`
  position: relative;
  width: 565px;
  height: 447px;
  background: linear-gradient(173deg, #11388c 0%, #11388c 100%);
  border-radius: 20px;
  .vip-img {
    display: block;
    margin: 42px 54px 0;
    width: 456px;
    height: 278px;
  }
`

const PolygonDescContainer = styled.div`
  width: 565px;
  height: 447px;
  background: #11388c;
  border-radius: 20px;
  .title {
    margin: 27px auto 0;
    font-size: 28px;
    font-family: HelveticaNeue-Medium, HelveticaNeue;
    font-weight: 500;
    color: #fff;
    text-align: center;
  }
`
const PolygonDescContent = styled.div`
  width: 488px;
  height: 345px;
  background: #133e9c;
  border-radius: 6px;
  margin: 17px 28px 19px 49px;
  padding: 27px 21px;
  font-size: 18px;
  font-family: Helvetica;
  color: #6090f8;
  line-height: 25px;
  p:not(:first-child) {
    margin-top: 21px;
  }
`

const PolygonVipContent = styled.div`
  width: 100%;
  height: 211px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: url(${rect_img}) no-repeat center center;
  padding: 63px 42px 0;
  .t1 {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
  }
  .t2 {
    font-size: 16px;
    margin-top: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #6090f8;
    font-weight: 500;
    line-height: 22px;
  }
`
